import { TFunction } from 'i18next'
import { Translation } from 'vanilla-cookieconsent'
import { availableLanguages } from 'domain/models/Translations/Translation'
import {
  AD_PERSONALIZATION,
  AD_STORAGE,
  AD_USER_DATA,
  ANALYTICS_STORAGE
} from './CookieConsentConfig'

export const cookieTranslation =
  (t: TFunction<'cookie'>) =>
  (lng: availableLanguages): Translation => {
    const consentModal = t('consentModal', {
      returnObjects: true,
      lng
    })

    const preferencesModal = t('preferencesModal', {
      returnObjects: true,
      lng
    })

    return {
      consentModal,
      preferencesModal: {
        ...preferencesModal,
        sections: [
          t('sections.description', { lng, returnObjects: true }),
          {
            ...t('sections.adStorage', { lng, returnObjects: true }),
            linkedCategory: AD_STORAGE
          },
          {
            ...t('sections.adUserData', { lng, returnObjects: true }),
            linkedCategory: AD_USER_DATA
          },
          {
            ...t('sections.adPersonalization', { lng, returnObjects: true }),
            linkedCategory: AD_PERSONALIZATION
          },
          {
            ...t('sections.analyticsStorage', { lng, returnObjects: true }),
            linkedCategory: ANALYTICS_STORAGE
          }
        ]
      }
    }
  }
